import _arrayFilter_default from "./_arrayFilter.js";
import stubArray_default from "./stubArray.js";

//#region ../../node_modules/lodash-es/_getSymbols.js
/** Used for built-in method references. */
var objectProto = Object.prototype;
/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;
var nativeGetSymbols = Object.getOwnPropertySymbols;
/**
* Creates an array of the own enumerable symbols of `object`.
*
* @private
* @param {Object} object The object to query.
* @returns {Array} Returns the array of symbols.
*/
var getSymbols = !nativeGetSymbols ? stubArray_default : function(object) {
	if (object == null) return [];
	object = Object(object);
	return _arrayFilter_default(nativeGetSymbols(object), function(symbol) {
		return propertyIsEnumerable.call(object, symbol);
	});
};
var _getSymbols_default = getSymbols;

//#endregion
export { _getSymbols_default as default };
//# sourceMappingURL=_getSymbols.js.map